import { render } from "./Config_Evenement.vue?vue&type=template&id=b6c07444"
import script from "./Config_Evenement.vue?vue&type=script&lang=js"
export * from "./Config_Evenement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__